const initialState = {
  firmGstPanDetails: {},
  addedFirms: [],
  editingIndustry: {},
  addingDealershipFromProfile: {},
  addingFirmFromProfile: false,
};

const firmOnbaordingReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_FIRM_ONBOARDING_REDUCER': {
      return initialState;
    }
    case 'SET_ADDING_DEALERSHIP_FROM_PROFILE': {
      return {
        ...state,
        addingDealershipFromProfile: action.data,
      };
    }
    case 'SET_ADDING_FIRM_FROM_PROFILE': {
      return {
        ...state,
        addingFirmFromProfile: action.data,
      };
    }
    case 'PARTIAL_RESET_FIRM_ONBOARDING_REDUCER': {
      return {
        ...initialState,
        addedFirms: state.addedFirms,
        addingFirmFromProfile: state.addingFirmFromProfile,
      };
    }
    case 'SET_FIRM_GST_PAN_DETAILS': {
      return {
        ...state,
        firmGstPanDetails: action.data,
      };
    }
    case 'SET_EDITING_INDUSTRY': {
      return {
        ...state,
        editingIndustry: action.data,
      };
    }
    case 'REMOVE_ROLE': {
      const tempAddedFirm = state.addedFirms || [];
      const { firm, role } = action.data;

      let found = tempAddedFirm.find(
        (item) => item.document_id === firm.document_id,
      );

      if (found) {
        delete found.roles[role.manufacturer_id];

        const finalUpdatedArr = tempAddedFirm.map((item) => {
          if (item.document_id === firm.document_id) {
            return found;
          } else {
            return item;
          }
        });

        return {
          ...state,
          addedFirms: finalUpdatedArr,
        };
      } else return state;
    }
    case 'ADD_FIRM': {
      const tempAddedFirm = state.addedFirms || [];

      const found = tempAddedFirm.find(
        (item) => item.document_id === action.data.document_id,
      );

      if (found) {
        tempAddedFirm.splice(
          tempAddedFirm.findIndex(
            (doc) => doc.document_id === action.data.document_id,
          ),
          1,
          action.data,
        );
        return {
          ...state,
          addedFirms: tempAddedFirm,
        };
      } else {
        return {
          ...state,
          addedFirms: [...tempAddedFirm, action.data],
        };
      }
    }
    case 'REMOVE_FIRM': {
      const tempAddedFirm = state.addedFirms || [];
      const data = action.data;
      const finalUpdatedArr = tempAddedFirm.filter(
        (item) => item.document_id !== data.document_id,
      );

      return {
        ...state,
        addedFirms: finalUpdatedArr,
      };
    }
    default:
      return state;
  }
};

export default firmOnbaordingReducer;
